import React from "react";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import Fab from '@material-ui/core/Fab';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Zoom from '@material-ui/core/Zoom';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import HomeIcon from '@material-ui/icons/Home';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        bottom: theme.spacing(10),
        right: theme.spacing(2),
        zIndex: 999,
    },
    home: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 999,
    },
    back: {
        position: 'fixed',
        bottom: theme.spacing(10),
        right: theme.spacing(2),
        zIndex: 555,
    },
}));

const ScrollTop = (props) => {
    const { home } = props;
    const classes = useStyles();
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    };

    const scrollToTopIcon = (
        <Tooltip title="Go to Top." arrow placement="top-end">
            <Fab color="primary" aria-label="Scroll to top.">
                <ArrowUpwardIcon />
            </Fab>
        </Tooltip>);

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" className={home ? classes.home : classes.root}>
                {scrollToTopIcon}
            </div>
        </Zoom>
    );
}

export const GoHome = (props) => {
    const { setPage } = props;

    const classes = useStyles();
    const history = useHistory();
    const routeChange = React.useCallback(path => {
        history.push(path);
    }, [history]);

    const goHome = () => {
        if(setPage !== undefined){
            setPage(0);
        }
        routeChange("/");
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    return (
        <div onClick={goHome} role="presentation" className={classes.home}>
            <Tooltip title="Go to Home page." arrow placement="top-end">
                <Fab color="primary" aria-label="Go to Home page.">
                    <HomeIcon />
                </Fab>
            </Tooltip>
        </div>);
}

export const GoBack = () => {
    const classes = useStyles();
    const history = useHistory();

    const goBack = () => history.goBack();

    return (
        <div onClick={goBack} role="presentation" className={classes.back}>
            <Tooltip title="Go back." arrow placement="top-end">
                <Fab color="primary" aria-label="Go back.">
                    <ArrowBackIcon />
                </Fab>
            </Tooltip>
        </div>);
}

export default ScrollTop;